export default __webpack_public_path__ + "static/media/ic-coberturas.480504ce.svg";